import { FeatureFlag, useFeatureFlagValue } from "../../feature-flags";

/** Selects the converged Work Pattern Import experience. */
export function useWorkPatternImportRedesignEnabled(): boolean {
  return useFeatureFlagValue(FeatureFlag.EnableWorkPatternImportRedesign);
}
